import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Library
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatTableResponsiveModule } from '../../mat-table-responsive/mat-table-responsive.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
// import { NgxCopyToClipboardModule } from 'ngx-copy-to-clipboard';

import { DragDropModule } from '@angular/cdk/drag-drop';

// import { AboutPageComponent } from './components/about-page/about-page.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PoweredByFooterComponent } from './components/powered-by-footer/powered-by-footer.component';
// import { PostManComponent } from './components/post-man/post-man.component';
// import { CartListPage } from './modals/cart-list/cart-list.page';
// import { DialogBoxComponent } from './components/dialog-box/dialog-box.component';

import { NgJsonEditorModule } from 'ang-jsoneditor';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
// import { SchedularComponent } from './modals/scheduler/schedular.component';
import { MatNativeDateModule } from '@angular/material/core';
// import { EnvironmentListPage } from './modals/environment-list/environment-list.page';
import { MatGridListModule } from '@angular/material/grid-list';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
// import { AboutUsPage } from '../about-us/about-us.page';
import { MultiFactorComponent } from './modals/multi-factor/multi-factor.component';
// import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};


@NgModule({
  declarations: [
    HeaderComponent,
    // AboutPageComponent,
    FooterComponent,
    PoweredByFooterComponent,
    // PostManComponent,
    // CartListPage,
    // SchedularComponent,
    // DialogBoxComponent,
    // EnvironmentListPage,
    // AboutUsPage,
    MultiFactorComponent,
    // SideNavigationComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatDividerModule,
    MatStepperModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTabsModule,
    MatRadioModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatTableResponsiveModule,
    MatTooltipModule,
    MatExpansionModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgJsonEditorModule,
    PerfectScrollbarModule,
    MatDialogModule,
    MatGridListModule,
    CodemirrorModule,
    MatButtonToggleModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    PoweredByFooterComponent,
    // AboutPageComponent,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatDividerModule,
    MatStepperModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTabsModule,
    MatRadioModule,
    MatSortModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTableResponsiveModule,
    MatTooltipModule,
    MatExpansionModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    // PostManComponent,
    NgJsonEditorModule,
    // CartListPage,
    MatDialogModule,
    // EnvironmentListPage,
    CodemirrorModule,
    MatButtonToggleModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { strict: true } },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]

})
export class SharedModule { }
